/* eslint-disable no-script-url */
import { sendTeaCommEvent } from 'lib/tea-analyze'
import PubSub from 'pubsub-js'
import React, { useEffect, useState } from 'react'
import { EInfoMode, INFO_MODE_KEY } from 'Components/new/info-mode-switcher'
import RankFlag from '../../components/rank-publish-flag'

export interface IConfig {
  id: string // 唯一标示
  icon?: string // icon-type
  foldIcon?: string // 折叠时使用的icon
  name: string // 菜单名称
  foldName?: string // 折叠时使用的菜单名称
  hoverComponent?: boolean // hover情况下 右侧渲染组件
  link?: string // 点击跳转链接 高亮匹配依据
  as?: string // 浏览器url 没有则不跳转
  newVersionLink?: string // pc3.0 对应的page path
  children?: IConfig[] // 如果存在children 则 link 不生效
  isActive?: (url: string, user_id?: string) => boolean // 自定义高亮规则
  onClick?: () => void // 自定义点击事件
  hoverOnOff?: boolean
  onMouseEnter?: () => void // 自定义事件
  onMouseLeave?: () => void // 自定义事件
  isNeedLogin?: boolean // 点击是否需要登陆
  loginMethod?: string // 登陆唤起传入的enter_method
  extraComponent?: (className?: string) => JSX.Element
  target?: '_self' | '_blank'
}

// hover 选车 延迟展开
let timer: any = null

const showChild = (id: string) => {
  timer = setTimeout(() => {
    PubSub.publish('HOVER_NAV_CHILD', {
      status: true,
      id,
    })
    timer = null
  }, 200)
}

const hideChild = (id: string) => {
  if (timer) {
    window.clearTimeout(timer)
    timer = null
  } else {
    setTimeout(() => {
      PubSub.publish('HOVER_NAV_CHILD', {
        status: false,
        id,
      })
    }, 100)
  }
}

// 新老版本同时存在 只能a标签跳转
export default function useConfig(): IConfig[] {
  const [config, setConfig] = useState<IConfig[]>([
    {
      id: 'home',
      icon: 'icon_home',
      foldIcon: 'icon_home_filled',
      name: '首页',
      link: '/home',
      newVersionLink: '/new_home',
      as: '/',
    },
    {
      id: 'select-car',
      icon: 'icon_car_24',
      foldIcon: 'icon_car_filled',
      name: '选车',
      hoverComponent: true,
      link: '/auto/home',
      newVersionLink: '/auto/library/x-x-x-x-x-x-x-x-x-x-x',
      as: '/auto/library/x-x-x-x-x-x-x-x-x-x-x',
      isActive: (url: string) => {
        // 选车页面
        return /\/auto\/library((-energy)|(-brand)|(-picture)|(-accurate))?\//.test(
          url
        )
      },
      onClick: () => {
        PubSub.publish('HIDE_HOVER_CAR')
      },
      onMouseEnter: () => {
        timer = setTimeout(() => {
          sendTeaCommEvent('show_event', {
            event_id: 'common_select_car_menu',
          })
          PubSub.publish('HOVER_CAR_STATUS', true)
          timer = null
        }, 100)
      },
      onMouseLeave: () => {
        if (timer) {
          window.clearTimeout(timer)
          timer = null
        } else {
          // 稍微延后 用户倾斜划入也能展现弹窗
          setTimeout(() => {
            PubSub.publish('HOVER_CAR_STATUS', false)
          }, 100)
        }
      },
    },
    {
      id: 'usedcar',
      icon: 'icon_usedcar',
      foldIcon: 'icon_usedcar_filled',
      name: '二手车',
      foldName: '二手车',
      link: '/usedcar/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x',
      as: '/usedcar/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x',
      hoverComponent: true,
      onMouseEnter: () => {
        timer = setTimeout(() => {
          PubSub.publish('HOVER_USEDCAR', true)
          timer = null
        }, 100)
      },
      onMouseLeave: () => {
        if (timer) {
          window.clearTimeout(timer)
          timer = null
        } else {
          // 稍微延后 用户倾斜划入也能展现弹窗
          setTimeout(() => {
            PubSub.publish('HOVER_USEDCAR', false)
          }, 100)
        }
      },
    },
    {
      id: 'video',
      icon: 'icon_play_2',
      foldIcon: 'icon_video_filled',
      name: '视频',
      link: '/video/home',
      as: '/video',
      isActive: (url: string) => {
        return /^\/videos?\//.test(url)
      },
      newVersionLink: '/new_video',
    },
    {
      id: 'feed',
      icon: 'icon_interact',
      foldIcon: 'icon_info_filled',
      name: '资讯',
      link: '/news/dynamic_motor_car',
      as: '/news/dynamic_motor_car',
      newVersionLink: '/news/dynamic_motor_car',
      isActive: (url: string) => {
        return url?.indexOf('/news') === 0 || url?.indexOf('/feed') === 0
      },
    },
    {
      id: 'fans',
      icon: 'icon_community_24',
      foldIcon: 'icon_community_filled',
      name: '车友圈',
      link: '/car_fans_community/home',
      as: '/car_fans_community',
    },
    {
      id: 'rank',
      icon: 'icon_list',
      foldIcon: 'icon_rank_filled',
      name: '排行榜',
      link: '/leaderboard/sales',
      as: '/sales',
      isActive: (url?: string) => {
        return url?.indexOf('/sales') === 0
      },
      extraComponent: (className) => <RankFlag className={className} />,
    },
    {
      id: 'live',
      icon: 'icon_icon_home_maichezhibo1x',
      foldIcon: 'icon_live_filled',
      name: '直播',
      link: '/live/home',
      as: '/live',
    },
    {
      id: 'tool',
      icon: 'icon_keyboard',
      foldIcon: 'icon_tools_filled',
      name: '小工具',
      foldName: '工具',
      children: [
        {
          id: 'compare',
          icon: 'icon_pk_24',
          name: '车型对比',
          link: '/auto/auto_compare/params',
          as: '/auto/auto_compare/params',
          target: '_blank',
        },
        {
          id: 'compute',
          icon: 'icon_calculate_24',
          name: '购车计算',
          link: '/price_calculator?type=fullpayment',
          as: '/calculator/fullpayment',
          isActive: (url: string) => {
            return url?.indexOf('/calculator/') === 0
          },
        },
      ],
      hoverOnOff: true,
      onMouseEnter: () => {
        showChild('tool')
      },
      onMouseLeave: () => {
        hideChild('tool')
      },
    },
    {
      id: 'me',
      icon: 'icon_mine',
      foldIcon: 'icon_mine_filled',
      name: '我的',
      // link: '/profile',
      // newVersionLink: '/new_profile',
      // as: '/user/gzyh/{userId}',
      // isNeedLogin: true,
      // loginMethod: 'follow',
      children: [
        // {
        //   id: 'history',
        //   name: '浏览历史',
        //   link: '/me/history'
        // },
        {
          id: 'attention',
          name: '我的关注',
          icon: 'icon_diamonds',
          link: '/profile',
          newVersionLink: '/new_profile',
          as: '/user/gzyh/{userId}',
          isNeedLogin: true,
          loginMethod: 'follow',
          isActive: (url: string, user_id?: string) => {
            // 必须在我的关注下面
            const reg = new RegExp(`gz\\w+\\/${user_id}\\??`)
            return reg.test(url)
          },
        },
        {
          id: 'collect',
          name: '我的收藏',
          icon: 'icon_works_24',
          link: '/new_collect',
          as: '/user/favor',
          isNeedLogin: true,
          loginMethod: 'favorite',
          isActive: (url: string) => {
            return url?.indexOf('/user/favor') > -1
          },
        },
      ],
      hoverOnOff: true,
      onMouseEnter: () => {
        showChild('me')
      },
      onMouseLeave: () => {
        hideChild('me')
      },
    },
    {
      id: 'feedback',
      name: '用户反馈',
      foldName: '反馈',
      icon: 'icon_compose_24',
      foldIcon: 'icon_edit_filled',
      onClick: () => {
        PubSub.publish('OPEN_FEEDBACK')
      },
    },
  ])
  useEffect(() => {
    const infoMode =
      window.localStorage.getItem(INFO_MODE_KEY) || EInfoMode.STATIC
    if (infoMode === EInfoMode.STATIC) return
    const newConfig = [...config]
    const feed = newConfig.find((item) => item.id === 'feed') as IConfig
    feed.link = '/feed/home'
    feed.as = '/feed'
    feed.newVersionLink = '/feed'
    setConfig(newConfig)
  }, [])
  return config
}
